/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-25 16:36:37
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-09 17:09:23
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer/index.tsx
 */
import React from 'react';

import css from './css.less';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { ChannelType } from 'src/types/common/SalesChannel';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { Icon } from '@/src/tools/icon';
import { get } from 'lodash';
import SizeContainer from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer';
import { WebSiteSubType } from 'src/types/common/SalesChannel';
import { ErrorBoundary } from 'src/components/ErrorBoundary';

const RightContainer = (props) => {
  const { color } = props;
  return (
    <div className={css.miniRightContainer}>
      <div className={css.miniRightItem1}>
        <Icon type='icona-MPmore' style={{ color: color || '#fff' }} />
      </div>
      <div className={css.split} />
      <div className={css.miniRightItem}>
        <Icon
          type='icona-MPclose'
          // className={css.iconBack}
          style={{ color: color || '#fff' }}
        />
      </div>
      {/* <Icon
        type='icona-MPcapsule'
        //className={css.miniRightCircle}
        style={{ color: '#fff' }}
      /> */}
    </div>
  );
};

const PreviewContainer = (props) => {
  const {
    className,
    header,
    containerStyle,
    children,
    wrapperClassName,
    style,
    appearanceStyle,
    withoutCollapse,

    //contentUuid
  } = props;
  const bkg = get(appearanceStyle, 'backgroundColor');
  const arrowColor = get(appearanceStyle, 'arrowColor');
  const textColor = get(appearanceStyle, 'textColor');
  const operationIconColor = get(appearanceStyle, 'operationIconColor');

  const type = useSalesChannelType();
  const salesChannel = useSalesChannel();
  const { name } = salesChannel;
  //console.log('type', type);
  const isMini = type === ChannelType.MiniProgram;
  const renderFixedHeader = () => {
    if (isMini) {
      return (
        <div
          className={css.fixedHeader}
          style={{ backgroundColor: bkg || '#000' }}>
          <Icon
            type='icona-MPback'
            className={css.iconBack}
            style={{ color: arrowColor || '#fff' }}
          />
          <div className={css.namePart} style={{ color: textColor || '#fff' }}>
            {name}
          </div>
          <RightContainer color={operationIconColor} />
        </div>
      );
      //return _miniProgramRender();
    }
    if (type === ChannelType.Website) {
      // return _websiteRender();
      return null;
    }
    return null;
  };
  const miniContainerStyle = { height: isMini ? 'calc(100% - 60px)' : '100%' };
  return (
    <ErrorBoundary>
      <div
        style={style}
        className={
          withoutCollapse
            ? `${css.landscapeWrapper} ${wrapperClassName || ''}`
            : `${css.wrapper} ${wrapperClassName || ''}`
        }>
        {renderFixedHeader()}
        {header || null}
        <div
          style={{ ...(containerStyle || {}), ...miniContainerStyle }}
          className={`${css.container} ${className || ''}`}>
          {children}
        </div>
      </div>
    </ErrorBoundary>
  );
};

const PreviewWrapper = (props) => {
  const { children } = props;
  return <div className={css.previewContainer}>{children}</div>;
};
export { PreviewWrapper, PreviewStyleSwitch };
export default PreviewContainer;

const PreviewStyleSwitch = (props) => {
  const { style, styleChild, normalChild } = props;
  return style === WebSiteSubType.ResponsivePage ? (
    <SizeContainer>{styleChild}</SizeContainer>
  ) : (
    normalChild
  );
};
